import React, { useRef } from "react";
import { motion, useTransform, useScroll } from "framer-motion";
import multify from "../../assets/logo.webp"; // Ensure correct path

const WeAre = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: containerRef });

  // WHO ARE WE? Animations
  const whoScale = useTransform(scrollYProgress, [0, 0.3], [1, 4]);
  const whoOpacity = useTransform(scrollYProgress, [0, 0.35], [1, 0]);

  // WE ARE MULTIFY + Logo Animations
  const multifyOpacity = useTransform(scrollYProgress, [0.2, 0.45], [0, 1]);
  const multifyScale = useTransform(scrollYProgress, [0.2, 0.45], [0.8, 1]);

  return (
    <div
      ref={containerRef}
      className="relative h-[150vh] overflow-hidden bgCloud"
    >
      <div className="sticky top-0 h-screen flex items-center justify-center">
        {/* WHO ARE WE? */}
        <motion.h1
          style={{
            scale: whoScale,
            opacity: whoOpacity,
            transformStyle: "preserve-3d",
            transformPerspective: "1000px",
          }}
          transition={{ duration: 1.2, ease: [0.25, 1, 0.5, 1] }}
          className="absolute text-3xl sm:text-4xl md:text-6xl text-white text-center font-bold z-10 w-full"
        >
          WHO ARE WE?
        </motion.h1>

        {/* WE ARE MULTIFY + Logo */}
        <motion.div
          style={{
            scale: multifyScale,
            opacity: multifyOpacity,
            transformStyle: "preserve-3d",
            transformPerspective: "1000px",
          }}
          transition={{ duration: 1.5, ease: [0.25, 1, 0.5, 1] }}
          className="flex flex-col items-center w-full"
        >
          <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold text-white mb-4 sm:mb-6 text-center ">
            WE ARE
          </h1>
          <div className="flex justify-center pb-10 sm:pb-20">
            <img
              src={multify}
              alt="MULTIFY"
              className="w-3/4 sm:w-1/2 max-w-[100%] "
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default WeAre;
